import React, { useState, useEffect } from 'react';
import './css/custom.css';
//import Table from 'react-bootstrap/Table';


const LogoSelect = ({onPriceChange, onQuantityChange, onSizeChange, onCostChange}) => {
  const [data, setData] = useState([]);
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedQuantity, setSelectedQuantity] = useState('');
  const [additionalCost, setAdditionalCost] = useState(0);

  useEffect(() => {
    fetch('/pricingData.json')
      .then(response => response.json())
      .then(data => setData(data));
  }, []);

  const handleSizeChange = (event) => {
    const size = event.target.value;
    setSelectedSize(size);
    onSizeChange(size);
  };

  const handleQuantityChange = (event) => {
    const quantity = event.target.value;
    //console.log("test111");
    setSelectedQuantity(quantity);
    onQuantityChange(quantity);
  };

  const handleAdditionalFeeChange = (event) => {
    const additional = event.target.value;
    //console.log(additional);
    //console.log("test222");

    setAdditionalCost(additional);
    onCostChange(additional);
  };

  const selectedData = data.find(item => item.SIZE === selectedSize);
  let price = null;
  
  if (selectedData) {
    // Find the appropriate price based on the quantity ranges
    const quantityRanges = Object.keys(selectedData).filter(key => key !== 'SIZE');
    for (let range of quantityRanges) {
      const [min, max] = range.split('-').map(Number);
      if (selectedQuantity >= min && (max === '+' || selectedQuantity <= max)) {
        price = selectedData[range];
        break;
      }
    }
  }

  // Call the callback function with the selected price
  useEffect(() => {
    onPriceChange(price);
  }, [price, onPriceChange]);

  return (
    <div>
      <table>
        <tr className="label-distance">
          <td>Select Size :</td>
          <td>       
            <select value={selectedSize} onChange={handleSizeChange}>
              <option value=''>Select a Size</option>
              {data.map((item) => (
                <option key={item.SIZE} value={item.SIZE}>{item.SIZE}</option>
              ))}
            </select>
          </td>
        </tr>
        <tr className="label-distance">
          <td>Enter Quantity : </td>
          <td>
            <input 
              type="number" 
              value={selectedQuantity} 
              onChange={handleQuantityChange} 
              disabled={!selectedSize} 
              min="1"
            />
          </td>
        </tr>
        <tr>
          <td>Additional Cost (Digitize Logo) : </td>
          <td>
          $<input 
              type="number"
              value={additionalCost}
              onChange={handleAdditionalFeeChange}
              min="0"
            />
          </td>
        </tr>
      </table>
    </div>
  );
};

export default LogoSelect;
